module.exports = __webpack_public_path__ + "img/detail-1.fb3d9b8d.png";